export enum FormFieldConfigurationSaveReason {
    SwitchingToFormPreviewMode,
    SavingFormToServer
}
